import { Field } from "contentful"

export default function renderRichText(field: Field): string {
  return "Document"
}
